import { gql } from "graphql-tag";
import { withApi } from "src/stores/Api";
import {
  createProgram,
  createProgramVariables,
  deleteProgram,
  deleteProgramVariables,
  program,
  programVariables,
  programs,
  programsVariables,
  updateProgram,
  updateProgramVariables,
} from "types/code-generator";
import { TypedDocumentNode } from "types/graphql";

const ProgramPayloadFragment = gql`
  fragment ProgramPayload on Program {
    active
    billingCategory {
      id
      title
    }
    department {
      id
      title
    }
    description
    evaluationReminderFrequency
    hideInFilters
    id
    images {
      id
      url
    }
    integration
    classes {
      id
      status
    }
    membershipOfferings {
      id
      status
    }
    skills
    title
  }
`;

export const UpdateProgramMutation = gql`
  mutation updateProgram($data: ProgramCreateInput!, $where: UniqueInput!) {
    updateProgram(data: $data, where: $where) {
      ...ProgramPayload
    }
  }
  ${ProgramPayloadFragment}
` as TypedDocumentNode<updateProgram, updateProgramVariables>;

export const DeleteProgramMutation = gql`
  mutation deleteProgram($id: String!) {
    deleteProgram(where: { id: $id }) {
      id
    }
  }
` as TypedDocumentNode<deleteProgram, deleteProgramVariables>;

export const CreateProgramMutation = gql`
  mutation createProgram($data: ProgramCreateInput!) {
    createProgram(data: $data) {
      ...ProgramPayload
    }
  }
  ${ProgramPayloadFragment}
` as TypedDocumentNode<createProgram, createProgramVariables>;

export const ProgramsQuery = gql`
  query programs($where: ProgramWhereInput!) {
    programs(where: $where, orderBy: { order: asc }) {
      ...ProgramPayload
    }
  }
  ${ProgramPayloadFragment}
` as TypedDocumentNode<programs, programsVariables>;

export const ProgramQuery = gql`
  query program($where: UniqueInput!) {
    program(where: $where) {
      ...ProgramPayload
    }
  }
  ${ProgramPayloadFragment}
` as TypedDocumentNode<program, programVariables>;

export const QueryPrograms = withApi(ProgramsQuery, {
  name: "queryPrograms",
  skip: ({ visible, offering }) => {
    if (typeof visible === "boolean" && !offering) {
      return !visible;
    }
  },
  options: ({ store, session, match, form, classItem, offering }: any) => {
    const departmentIds = [];
    let addUserDepartments = true;

    if (match && match.params && match.params.departmentId) {
      departmentIds.push(match.params.departmentId);
      addUserDepartments = false;
    } else if (form && form.getFieldValue("department.id")) {
      departmentIds.push(form.getFieldValue("department.id"));
      addUserDepartments = false;
    } else if (classItem && classItem.department) {
      departmentIds.push(classItem.department.id);
    } else if (offering && offering.department) {
      departmentIds.push(offering.department.id);
      addUserDepartments = false;
    }

    if (store?.user && session && addUserDepartments) {
      session.departments.forEach((d) => departmentIds.push(d.id));
    }

    // if (departmentIds.length === 0 && store.organization.hasDepartments) {
    //   departmentIds.push(
    //     store.organization.departments.find((d) => d.default).id
    //   );
    // }

    const variables: programsVariables = {
      where: {
        organizationId: store.organization.id,
      },
    };

    if (store.organization.hasDepartments && departmentIds.length > 0) {
      variables.where.departmentId = {
        in: departmentIds,
      };
    }

    return {
      variables,
      fetchPolicy: "cache-and-network",
    };
  },
});
